import React,{useState} from "react";
import { useTranslation } from 'react-i18next';

import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl"
import OutlinedInput from '@mui/material/OutlinedInput';
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import Alert from '@mui/material/Alert';
import TextField from "@mui/material/TextField";


function ContactForm() {
    const { t, i18n } = useTranslation();

    const [bEmailError,setEmailError] = useState(false);
    const [bTextError,setTextError]   = useState(false);
    const [helperText, setHelperText] = useState('');
    const [oFormData,setFormData]     = useState({email: "",fullname:"",text:""});

    const [oAlertConfig, setAlertConfig] = useState({
        severity:"",
        msg:"",
        open: false
    })
    // const [oEntry, setEntry] = useState({});
    

    const handleFormChange = (oEvent, sParam) => {
       let currFormData =oFormData;

        currFormData[sParam] = oEvent.target.value;
        setFormData(currFormData);
    }

    const submitForm = async () => {

        let bEmailValid, 
            bEmailText,
            srvResp,
            oEntry = {};

        try {
            setEmailError(false);
            setTextError(false);

            if(!oFormData.email) {
                setEmailError("true");
                setHelperText('please enter a valid Emailaddress.');
                return;
            }

            bEmailValid = validateEmail(oFormData.email);

            if (!bEmailValid) {
                setEmailError("true");
                return;
            }

            // if no text was added then cancel
            bEmailText = !oFormData.text ? false : true;

            if(!bEmailText) {
                setTextError("true");
                return;
            }

            oEntry.senderMail = oFormData.email;
            oEntry.emailBody  = oFormData.text;
            oEntry.subject     = oFormData.fullname;
            
            srvResp = await  _submitMail(oEntry);

            setAlertConfig({
                severity: srvResp.status === 200 ? "success" : "error",
                msg:      srvResp.status === 200 ? t('contact_section.email_send_success') : t('contact_section.email_send_fail'),
                open: true
            });

            // Clear Email Form
            if (srvResp.status === 200) {
                setFormData({email: "",fullname:"",text:""})
            }

        }catch(e) {
            setAlertConfig({
                severity:"error",
                msg: t('contact_section.email_send_fail'),
                open: true
            });

            console.log(e);
        }
    }

    const validateEmail = (sEmail) => {

        // Regular expression for email validation
        var regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        // Return true if email matches regex, false otherwise
        return regex.test(sEmail);
    }

    const _submitMail = async (oEntry) => {

        try {
         let srvReq,
             srvResp,
             sPath,
             sLocalPath;

            // sLocalPath = "/nmailer_create"

            sPath    = process.env.REACT_APP_API_GW_DEV_URL + "/nmailer_create";
            srvReq   = await fetch(sPath, { method:'POST', body: JSON.stringify(oEntry), headers:{'Content-Type' : 'application/json' } });
            srvResp  = await srvReq.json();

            return(srvResp);
            
        }catch(e) {
            alert('Error.Couldnt Send Mail');
        }     
    }

    const handleClose = () => {
        setAlertConfig({
            severity:"",
            msg:"",
            open: false       
        })
    }

    return(
            <Box
                sx={{ width:'90%',
                    padding:'0rem',
                    margin:'1rem',
                    borderRadius:'1rem'
                }}>
                <Box 
                
                    sx={{ width:'100%', 
                        marginBottom:'2rem',
                        marginTop:'1rem',
                        display:'flex',
                        flexDirection:{ xs: 'column', sm:'column', md:'column', lg:'column', xl:'column'},
                        alignItems:{xs:'center', sm:'center', md:'center', lg:'center', xl:'center'}
                        
                        }}>

                 <Typography variant="h6" sx={{fontWeight:'bold',margin:'0.5rem'}}>
                    {t('contact_section.leaveMsg')}
                </Typography>

                {/* <Divider flexItem orientation="vertical" sx={{ display:{xs: 'none', sm:'none', md:'none', lg:'block', xl:'block'}}}/> */}
                <Divider flexItem  sx={{ marginBottom:'1rem', display:{xs: 'block', sm:'block', md:'block', lg:'block', xl:'block'}}}/> 
                
                 <Snackbar 
                    open={oAlertConfig.open}
                    autoHideDuration={3000}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    sx={{bottom:'5rem'}}
                    >
                <Alert
                    severity={oAlertConfig.severity}
                    sx={{ marginBottom:'1rem', width: '20rem', marginTop:'0.2rem'}}>
                        {oAlertConfig.msg}
                    </Alert> 
                </Snackbar>                        
                        <FormControl>
                            <OutlinedInput 
                                id="inpt_fullName"
                                onChange={(oEvent) => handleFormChange(oEvent,'fullname')}
                                placeholder={t('contact_section.tltp_fullname')}  
                                aria-describedby="fullName_hText-text" 
                                sx={{ 
                                    width: { xs:'15rem',sm: '15rem', md:'20rem', lg:'20rem', xl:'20rem'},
                                    marginBottom:'1rem' }}/>
                            {/* <FormHelperText id="fullName_hText">helper text name</FormHelperText> */}
                        </FormControl>

                        <FormControl>
                            <OutlinedInput 
                                id="my-inpt_email"
                                required={true}
                                error={bEmailError}
                                onChange={(oEvent) => handleFormChange(oEvent,'email')}
                                helpertext="test helper"
                                placeholder={t('contact_section.tltp_emailadress')} 
                                aria-describedby="email_HText" 
                                sx={{ 
                                width: { xs:'15rem',sm: '15rem', md:'20rem', lg:'20rem', xl:'20rem'},
                                 marginBottom:'1rem' 
                                 }}/>
                            {/* <FormHelperText id="email_HText">helper text email</FormHelperText> */}
                        </FormControl>
                        <FormControl>
                            <TextField 
                                required={true}
                                error={bTextError}
                                multiline
                                onChange={(oEvent) => handleFormChange(oEvent,'text')}
                                aria-label="minimum height"
                                rows={6}
                                placeholder=""
                                sx={{ marginBottom:'1rem',
                                      width: { xs:'15rem',sm: '15rem', md:'20rem', lg:'20rem', xl:'20rem' } }}                     
                            />
                            <Button onClick={submitForm} variant="contained" color="success">
                                    {t('contact_section.btn_send_msg')}
                            </Button>
                        </FormControl>
                        
                        
                </Box>
                
           
        </Box>




    )
}

export default ContactForm;